import { render, staticRenderFns } from "./ListaTerceiros.vue?vue&type=template&id=7524f9b9"
import script from "./ListaTerceiros.vue?vue&type=script&lang=js"
export * from "./ListaTerceiros.vue?vue&type=script&lang=js"
import style0 from "./ListaTerceiros.vue?vue&type=style&index=0&id=7524f9b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports